import { number_format, tracking } from '@bark/bark-core';
import { getCsSubCustomPackageData } from './cs-subscription-api';
import { trackingPayload } from './cs-subscription-tracking';
import { debounce } from 'lodash';

export default function (csSubscriptionPayment) {
	const refreshCustomPackData = async () => {
		$('#js-select-package-custom').addClass('disabled').attr('disabled', true);
		csSubscriptionPayment.removePackage('custom');

		validateCustomPackNLeadsInput();

		let nLeads = getCustomPackNLeads();

		if (nLeads === '') {
			updateCustomPackData({});
			return;
		}

		const paymentFrequency = csSubscriptionPayment.getSelectedPaymentFrequency();

		tracking('credit-subscription-self-service-page', 'custom_package_edited', {
			...trackingPayload,
			n_leads: nLeads,
			payment_frequency: paymentFrequency,
		});

		if (paymentFrequency === 'week') {
			nLeads = convertToMonthlyNLeads(nLeads);
		}

		const packagesData = await getCsSubCustomPackageData(false, nLeads);
		let customPackData = packagesData?.data?.packages
			? packagesData.data.packages.find(({ name }) => name === 'custom')
			: {};
		customPackData.n_leads = nLeads;

		updateCustomPackData({
			creditsPerMonth: customPackData?.credits_per_month,
			creditsPerWeek: customPackData?.credits_per_week,
			pricePerMonth: number_format(
				(customPackData?.price_per_month_in_pence ?? 0) / 100,
				2,
			),
			pricePerWeek: number_format(
				(customPackData?.price_per_week_in_pence ?? 0) / 100,
				2,
			),
			leadsPerMonth: customPackData?.purchased_leads_per_month,
			leadsPerWeek: customPackData?.purchased_leads_per_week,
			pricePerCredit: number_format(
				(customPackData?.price_per_credit_in_pence ?? 0) / 100,
				2,
			),
			discountPercentage: customPackData?.discount_percentage ?? 0,
		});

		csSubscriptionPayment.addPackage(customPackData);
		$('#js-select-package-custom').removeClass('disabled').attr('disabled', false);
	};

	const validateCustomPackNLeadsInput = () => {
		const nLeads = getCustomPackNLeads();
		if (nLeads === '') return;
		$('#custom-pack-n-leads').val(parseInt(nLeads, 10));

		const paymentFrequency = csSubscriptionPayment.getSelectedPaymentFrequency();
		if (paymentFrequency === 'month' && nLeads < 10) $('#custom-pack-n-leads').val(10);
		if (paymentFrequency === 'month' && nLeads > 250) $('#custom-pack-n-leads').val(250);
		if (paymentFrequency === 'week' && nLeads < 2) $('#custom-pack-n-leads').val(2);
		if (paymentFrequency === 'week' && nLeads > 57) $('#custom-pack-n-leads').val(57);
	};

	const convertToMonthlyNLeads = (nLeads) => {
		let monthlyNLeads = Math.floor(nLeads * 4.34);
		if (monthlyNLeads < 10) monthlyNLeads = 10;
		if (monthlyNLeads > 250) monthlyNLeads = 250;
		return monthlyNLeads;
	};

	const updateCustomPackData = ({
		creditsPerMonth = '---',
		creditsPerWeek = '---',
		pricePerMonth = '---',
		pricePerWeek = '---',
		leadsPerMonth = '',
		leadsPerWeek = '',
		pricePerCredit = '---',
		discountPercentage = '',
	}) => {
		$('#custom-pack-n-credits-per-month').html('').html(creditsPerMonth);
		$('#custom-pack-n-credits-per-week').html('').html(creditsPerWeek);
		$('#custom-pack-ppm').html('').html(pricePerMonth);
		$('#custom-pack-ppw').html('').html(pricePerWeek);
		$('#custom-pack-n-leads-month').val(leadsPerMonth);
		$('#custom-pack-n-leads-week').val(leadsPerWeek);
		$('#custom-pack-ppc').html('').html(pricePerCredit);
		$('#custom-pack-discount-perc').html('');
		if (discountPercentage)
			$('#custom-pack-discount-perc').html(discountPercentage + '% off');
	};

	const bindCustomPackListeners = () => {
		$('#custom-pack-n-leads').on('input', debounce(refreshCustomPackData, 500));
	};

	const getCustomPackNLeads = () => {
		if ($('#custom-pack-n-leads').val() !== '')
			return Number($('#custom-pack-n-leads').val());

		return $('#custom-pack-n-leads').val();
	};

	return {
		bindCustomPackListeners,
		refreshCustomPackData,
		getCustomPackNLeads,
	};
}


